

















// Importing components
import ThePreviewCart from './ThePreviewCart.vue';
import ThePreviewProducts from './ThePreviewProducts.vue';
import BaseSection from '@/ui/BaseSection.vue';

export default {
    name: 'ThePreviewMenu',
    components: {
        BaseSection,
        ThePreviewCart,
        ThePreviewProducts,
    },
    props: {
        search: String,
    },
};
